import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Undefined' },
    { value: 1, label: 'KAMAR' },
    { value: 2, label: 'MUSAC' },
    { value: 3, label: 'SIMS' },
    { value: 4, label: 'Integris' },
    { value: 5, label: 'Arbor' },
    { value: 6, label: 'Bromcom' },
    { value: 7, label: 'Civica' },
    { value: 8, label: 'iSAMS' },
    { value: 9, label: 'WCBS' },
  ],
});
